<template>
  <SlideSidebarContainer>
    <template v-slot:title>
      <span>Categorias</span>
    </template>

    <CategoriesNavbar />
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import CategoriesNavbar from '@/components/layout/CategoriesNavbar'

  export default {
    components: {
      CategoriesNavbar,
      SlideSidebarContainer,
    },
  }
</script>